import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { styled } from '@mui/system'
import Grid from '@mui/material/Grid2'

import Button from '@mui/material/Button'

import AuthContext from '@cpg-its/ads.auth.auth-context'

import AuthView from './components/demo/AuthView'
import UnAuthView from './components/demo/UnAuthView'

const PageWrapper = styled(Grid)({
  margin: '2rem',
})

const DemoPage = ({
  auth0LogoutUrl,
  cpgLogoutUrl,
}) => {
  const { error, loginWithRedirect, isLoading, isAuthenticated } = useContext(AuthContext)

  if (error) {
    if (error === 'Login required') {
      return (
        <Button
          onClick={loginWithRedirect}
        >
          Log in
        </Button>
      )
    }
    return (
      <Grid>
        {error}
      </Grid>
    )
  }

  if (isLoading) {
    return 'Loading...'
  }

  return (
    <PageWrapper>
      {!isAuthenticated && (
        <UnAuthView />
      )}
      {isAuthenticated && (
        <AuthView
          auth0LogoutUrl={auth0LogoutUrl}
          cpgLogoutUrl={cpgLogoutUrl}
        />
      )}
    </PageWrapper>
  )
}

DemoPage.propTypes = {
  auth0LogoutUrl: PropTypes.string,
  cpgLogoutUrl: PropTypes.string,
}

export default DemoPage
